import React, { useState, useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import axios from "../axios/axiosInstance";
import moment from "moment";
import "moment/locale/fr";
import { Link } from "react-router-dom";
import logo2 from "../assets/img/logonv.png";

export default function OffresEmploi() {
  const [emplois, setEmplois] = useState([]);
  const [annonces, setAnnonces] = useState([]);
  const [isDetailsShowed, setIsShowedDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [filteredAnnonces, setFilteredAnnonces] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(20);
  moment.locale("fr");

  const showDetails = () => {
    setIsShowedDetails(true);
  };

  function formaterDateFr(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  const loadAnnonces = () => {
    setIsLoading(true);
    axios
      .get(`annonces/website`)
      .then((res) => {
        setAnnonces(res.data);
        console.log(res.data);

        setFilteredAnnonces(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSearch = () => {
    const filtered = annonces.filter(
      (annonce) =>
        annonce.title &&
        annonce.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
        annonce.localisation &&
        annonce.localisation
          .toLowerCase()
          .includes(searchLocation.toLowerCase()),
    );
    setFilteredAnnonces(filtered);
    setCurrentPage(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const resetFilters = () => {
    setSearchTerm("");
    setSearchLocation("");
    setFilteredAnnonces(annonces);
    setCurrentPage(1);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredAnnonces.slice(
    indexOfFirstPost,
    indexOfLastPost,
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredAnnonces.length / postsPerPage);

  useEffect(() => {
    loadAnnonces();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-[154px] pb-10">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Trouvez votre prochain emploi
              </h1>
              <p className="text-lg text-gray-700 mb-8">
                Découvrez des offres d'emploi adaptées à vos compétences et à
                vos aspirations professionnelles.
              </p>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label
                      htmlFor="keyword"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Mot-clé ou titre
                    </label>
                    <Input
                      id="keyword"
                      type="text"
                      placeholder="Ex: Manutentionnaire, Chauffeur..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="location"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Lieu
                    </label>
                    <Input
                      id="searchLocation"
                      type="text"
                      placeholder="Ex: Paris, Lyon..."
                      value={searchLocation}
                      onChange={(e) => setSearchLocation(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
                <div className="flex justify-center">
                  <Button
                    className="bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={handleSearch}
                  >
                    Rechercher
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 ml-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </Button>
                  <Button
                    className="ml-4 bg-gray-200 hover:bg-gray-300 text-gray-700"
                    onClick={resetFilters}
                  >
                    Réinitialiser les filtres
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900">
                Offres d'emploi récentes
              </h2>
            </div>

            <div className="space-y-6">
              {currentPosts.length > 0 ? (
                currentPosts.map((annonce) => (
                  <div
                    key={annonce.id}
                    className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="flex flex-col md:flex-row justify-between">
                      <div className="mb-4 md:mb-0">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">
                          {annonce.title}
                        </h3>
                        <div className="flex flex-wrap gap-2 mb-3">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            {annonce.jobType}
                          </span>
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                            {annonce.tempTravail}
                          </span>
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            Publiée {moment(annonce.createdAt).fromNow()}
                          </span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-center text-gray-600 text-sm gap-3 mb-3">
                          <div className="flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 mr-1"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                            {annonce.localisation}
                          </div>
                          <div className="flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 mr-1"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            {annonce.dateDebutSouhaitee}
                          </div>
                        </div>
                        <p className="text-gray-700 mb-4 text-justify">
                          {annonce.description
                            ? annonce.description
                                .split("\n")
                                .slice(0, 5)
                                .join(" ")
                            : "Aucune description disponible"}
                        </p>
                      </div>
                      <div className="flex flex-col justify-between items-end">
                        <div className="w-full md:w-auto flex flex-col">
                          <Link to={`/detail/${annonce._id}`}>
                            <Button
                              variant="outline"
                              className="w-full md:w-auto bg-blue-600 text-white"
                            >
                              Voir détails
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">
                  Aucune offre d'emploi disponible pour le moment.
                </p>
              )}
            </div>

            <div className="mt-10 flex justify-center">
              <nav
                className="inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <a
                  href="#"
                  className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  onClick={() =>
                    setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)
                  }
                >
                  <span className="sr-only">Previous</span>
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                {[...Array(totalPages)].map((_, index) => (
                  <a
                    href="#"
                    key={index}
                    className={`relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium ${currentPage === index + 1 ? "text-blue-600 bg-blue-50" : "text-gray-700 hover:bg-gray-50"}`}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </a>
                ))}
                <a
                  href="#"
                  className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  onClick={() =>
                    setCurrentPage(
                      currentPage < totalPages ? currentPage + 1 : totalPages,
                    )
                  }
                >
                  <span className="sr-only">Next</span>
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </nav>
              {isLoading && (
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-[9999]">
                  <img
                    src={logo2}
                    alt="Chargement..."
                    className="w-20 h-20 animate-spin duration-1015"
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
